import {TokenInfo} from 'constData'

export const assetDefaultInfo = {
  enabled: true,

  // for wallet enabling deposits and withdrawals buttons and pages
  canDeposit: false,
  canWithdraw: false,
  canBuy: false,

  // to hide tables
  showDeposits: true,
  showWithdrawals: true,

  // for withdrawal to show memo tag
  withMemo: false,

  // other
  comingSoon: false,
  disabled: false,

  // CTP views config
  showAutomaticWalletAddress: true,
  showProducedToken: true,
}

export const fiatConfig = {
  canDeposit: false,
  canWithdraw: false,
  showExchanges: false,
  comingSoon: true,
}

export const assetsConfig = [
  {
    // Wallet info views config
    id: TokenInfo.MBASE.apiId,
    canWithdraw: true,
    canDeposit: true,
    canBuy: true,
    showDeposits: true,
    showWithdrawals: true,
    convertedTokenList: true,
    userPromotionBonus: true,
    showPurchasedTokens: true,
    showUserIncentiveAwarded: true,
    showUserCtpBooster: true,
    showFastStartBonus: true,

    // CTP views config
    showOwnWalletAddress: true,
    showStakeToken: true,
    showPeriodOfTime: true,
    showSponsorbonuses: true,
    showPromotionBonuses: true,
  },
  {
    id: 'XON',
    canWithdraw: true,
    canDeposit: true,
    canBuy: true,
    showDeposits: true,
    showWithdrawals: true,
    showPurchasedTokens: true,
  },
  {
    id: 'VIME',
  },
  {
    id: 'ETH',
    canDeposit: true,
    mbaseWithdrawalFees: true,
    interconnectFees: true,
    showPurchasedTokenFees: true,
  },
  {
    id: 'USDT',
    canDeposit: true,
    canWithdraw: true,
    interconnectFees: true,
    mbaseWithdrawalFees: true,
    showUserIncentiveAwarded: true,
    showPurchasedTokenFees: true,
    showChristmasIncentives: true,
  },
]
